import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-redeemable-in-filter',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './redeemable-in-filter.component.html',
  styleUrl: './redeemable-in-filter.component.scss'
})
export class RedeemableInFilterComponent {
  @Output() public redeemableInChange: EventEmitter<string> = new EventEmitter<string>();

  public selectedRedeemableIn: string;

  public onRedeemableInClick(value: string): void {
    this.selectedRedeemableIn = value === this.selectedRedeemableIn ? null : value;
    this.redeemableInChange.emit(this.selectedRedeemableIn);
  }
}
